<template>
    <modal :show="show" v-if=" isValid('CanAddColor') || isValid('CanEditColor') ">

        <div style="margin-bottom:0px" class="card" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="modal-header" v-if="type=='Edit'">

                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='WarrantyCategory'">{{ $t('ReparingOrder.UpdateWarrantyCategory') }} </h5>
                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='UpsDescription'">{{ $t('ReparingOrder.UpdateUpsDescription') }} </h5>
                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='Problem'">{{ $t('ReparingOrder.UpdateWarrantyProblem') }} </h5>
                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='AcessoryIncluded'">{{ $t('ReparingOrder.UpdateAcessoryIncluded') }} </h5>
                            

                        </div>
                        <div class="modal-header" v-else>

                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='WarrantyCategory'">{{ $t('ReparingOrder.AddWarrantyCategory') }} </h5>
                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='UpsDescription'">{{ $t('ReparingOrder.AddUpsDescription') }} </h5>
                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='Problem'">{{ $t('ReparingOrder.AddWarrantyProblem') }} </h5>
                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="formName=='AcessoryIncluded'">{{ $t('ReparingOrder.AddAcessoryIncluded') }} </h5>
                           

                        </div>
                        <div>
                            <div class="card-body ">
                                <div class="row ">
                                    
                                    <div v-if="english=='true'" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.reparingOrder.name.$error} && $i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                        <label class="text  font-weight-bolder"> {{ $t('ReparingOrder.ReparingOrderName') |englishLanguage}}: <span class="LabelColour"> *</span></label>
                                        <input class="form-control" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'" v-model="$v.reparingOrder.name.$model" type="text" />
                                        <span v-if="$v.reparingOrder.name.$error" class="error">
                                            <span v-if="!$v.reparingOrder.name.required">{{ $t('reparingOrder.NameRequired') }}</span>
                                            <span v-if="!$v.reparingOrder.name.maxLength">{{ $t('reparingOrder.NameLength') }}</span>
                                        </span>
                                    </div>
                                    <div v-if="arabic=='true'" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.reparingOrder.nameArabic.$error}">
                                        <label class="text  font-weight-bolder"> {{ $t('ReparingOrder.ReparingOrderName') |arabicLanguage}}: <span class="LabelColour"> *</span></label>
                                        <input class="form-control arabicLanguage " v-model="$v.reparingOrder.nameArabic.$model" type="text" />
                                        <span v-if="$v.reparingOrder.nameArabic.$error" class="error">
                                            <span v-if="!$v.reparingOrder.nameArabic.required"> {{ $t('reparingOrder.NameRequired') }}</span>
                                            <span v-if="!$v.reparingOrder.nameArabic.maxLength">{{ $t('reparingOrder.NameLength') }}</span>
                                        </span>
                                    </div>


                                 
                                    <div class="form-group col-md-12" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                        <label style="margin: 7px;">{{ $t('ReparingOrder.Status') }}</label> <br />
                                        <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" v-bind:class="{'bootstrap-switch-on': reparingOrder.isActive, 'bootstrap-switch-off': !reparingOrder.isActive}" v-on:click="reparingOrder.isActive = !reparingOrder.isActive" style="width: 72px;">
                                            <div class="bootstrap-switch-container" style="width: 122px; margin-left: 0px;">
                                                <span class="bootstrap-switch-handle-on bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-check-2"></i>
                                                </span>
                                                <span class="bootstrap-switch-label" style="width: 30px;">&nbsp;</span>
                                                <span class="bootstrap-switch-handle-off bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-simple-remove"></i>
                                                </span>
                                                <input class="bootstrap-switch" type="checkbox" data-toggle="switch" checked="" data-on-label="<i class='nc-icon nc-check-2'></i>" data-off-label="<i class='nc-icon nc-simple-remove'></i>" data-on-color="success" data-off-color="success">
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div v-if="!loading">
                            <div class="modal-footer justify-content-right" v-if="type=='Edit' && isValid('CanEditColor')">
                                <button type="button" class="btn btn-primary  " v-on:click="SaveImportExport" v-bind:disabled="$v.reparingOrder.$invalid"> {{ $t('ReparingOrder.btnUpdate') }}</button>
                                <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('ReparingOrder.btnClear') }}</button>
                            </div>
                            <div class="modal-footer justify-content-right" v-if="type!='Edit' && isValid('CanAddColor')">
                                <button type="button" class="btn btn-primary  " v-on:click="SaveImportExport" v-bind:disabled="$v.reparingOrder.$invalid"> {{ $t('ReparingOrder.btnSave') }}</button>
                                <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('ReparingOrder.btnClear') }}</button>
                            </div>
                        </div>
                        <div v-else>
                            <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </modal>
    <acessdenied v-else :model=true></acessdenied>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {  maxLength, requiredIf } from "vuelidate/lib/validators"
    export default {
        props: ['show', 'reparingOrder', 'type','formName'],
        mixins: [clickMixin],
        components: {
            Loading
        },
        data: function () {
            return {
                arabic: '',
                english: '',
                render: 0,
                loading: false,
            }
        },
        validations: {
            reparingOrder: {
                name: {
                    maxLength: maxLength(50)
                },
                nameArabic: {
                    required: requiredIf((x) => {
                        if (x.name == '' || x.name == null)
                            return true;
                        return false;
                    }),
                    maxLength: maxLength(50)
                },
               
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },
            
            SaveImportExport: function () {
                
                var root = this;
                this.loading = true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.post('/ReparingOrder/SaveReparingOrderTypeInformation', this.reparingOrder, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.isSuccess == true) {

                            if (root.type != "Edit") {

                                root.$swal({
                                    title: "Saved!",
                                    text: "Saved Successfully!",
                                    type: 'success',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                });

                                root.close();
                            }
                            else {

                                root.$swal({
                                    title: "Saved!",
                                    text: "Update Sucessfully!",
                                    type: 'success',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                });
                                root.close();
                            }
                        }
                        else {
                            root.$swal({
                                title: "Error!",
                                text: "Your ImportExport Name  Already Exist!",
                                type: 'error',
                                icon: 'error',
                                showConfirmButton: false,
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Something Went Wrong!',
                                text: error.response.data,

                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false
                    })
                    .finally(() => root.loading = false)
            }
        },
        mounted: function () {
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
           

        }
    }
</script>
